import { render } from "./MarketplaceInfoUpdate.vue?vue&type=template&id=60021665"
import script from "./MarketplaceInfoUpdate.vue?vue&type=script&lang=js"
export * from "./MarketplaceInfoUpdate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__